
import React from 'react';
import { bool, string } from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';
import spinner from '../../styles/assets/spinner.svg';

const useStyles = makeStyles(() => ({
  LoContainer: {
    width: 'calc(100% - 16px)',
    height: '60px',
    textAlign: 'center',
    margin: 'auto',
    lineHeight: '60px',
    pading: '10px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    backgroundColor: 'white',
  },
  '@keyframes loading': {
    '100%': {
      '-webkit-transform': 'rotate(360deg)',
      transform: 'rotate(360deg)',
    },
  },
  loading: {
    display: 'inline-block',
    verticalAlign: 'middle',
    margin: '0 10px',
    animationName: '$loading',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationDirection: 'linear',
    animationTimingFunction: 'ease-in-out',
  },
  withAnimation: ({ disabled }) => ({
    animationPlayState: disabled ? 'paused' : 'running',
  }),
}));

const LoadingIcon = ({ disabled, iconWidth }) => {
  const { LoContainer, loading, withAnimation } = useStyles({ disabled });
  return (
    <Box className={LoContainer}>
      <img
        src={spinner}
        alt="spinner-icon"
        className={`${loading} ${withAnimation}`}
        style={{ width: iconWidth }}
      />
    </Box>
  );
};

LoadingIcon.propTypes = {
  disabled: bool,
  iconWidth: string,
};

LoadingIcon.defaultProps = {
  disabled: false,
  iconWidth: '35px',
};

export default LoadingIcon;
